var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideoTransparency',_vm._g(_vm._b({attrs:{"src":_vm.activeVideo.url,"size":{ height: _vm.activeVideo.height, width: _vm.activeVideo.width }},on:{"ended":_vm.completeVideo}},'VideoTransparency',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24afd60d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/base/VideoSequence.vue
// module id = null
// module chunks = 